import { render, staticRenderFns } from "./DevAutomationPremiumInvoicePremiumReminder.vue?vue&type=template&id=12d84add"
import script from "./DevAutomationPremiumInvoicePremiumReminder.vue?vue&type=script&lang=js"
export * from "./DevAutomationPremiumInvoicePremiumReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports